export default {"src":"/_next/static/media/process-fee.d0d6cb23.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};